import { Component, OnInit, OnDestroy, HostListener } from "@angular/core";
import { SOTService } from "../../services";

/** SOTLayoutComponent was called, when sot is initilized */

@Component({
  selector: "sot-layout",
  templateUrl: "./sotLayout.component.html",
  styleUrls: ["./sotLayout.component.scss"],
})
export class SOTLayoutComponent implements OnInit, OnDestroy {

  /** intervall in demm nach empfangenen benutzer aktionen geprüft wird */
  private _checkHasUserActionDetectedInterval: NodeJS.Timer;
  /** wird gesetzt wenn eine Benutzer aktivität festgestellt wurde
   * um events nur im interval auszulösen und nicht ständig (wie beim move)
   */
  private _userActionDetectedBuffer: boolean = false;

  constructor(private _sotService: SOTService) {
    const me = this;
    console.debug("--- sot-layout constructor");
  }

  ngOnInit() {
    console.debug("--- sot-layout ngOnInit");
    const me = this;
    me._checkHasUserActionDetectedInterval = setInterval(() => {me.checkHasUserActionDetected()}, 1000); // für 1 sec. die events überfachen
    this.disableRightClick();
  }

  ngOnDestroy(): void {
    console.debug("--- sot-layout ngOnDestroy");
    const me = this;
    clearInterval(me._checkHasUserActionDetectedInterval);
  }

  /** wird im interval aufgerufen um festzustellen ob eine Action  */
  private checkHasUserActionDetected(): void {
    if (this._userActionDetectedBuffer) {
      this._sotService.userActionDetected();
      this._userActionDetectedBuffer = false; // reset, da detection gemeldet wurde
    }
  }

  private disableRightClick() {
    document.body.addEventListener("contextmenu", (e) => e.preventDefault() );
  }

  /** down, up und move werden für Maus, Finger und Stift überwacht */
  @HostListener('window:pointerdown')
  @HostListener('window:pointerup')
  @HostListener('window:pointermove') // pointermove wird nicht beim scrollen getriggert deswegen touchmove
  @HostListener('window:touchmove')
  userActionDetected() {
    this._userActionDetectedBuffer = true; // buffert aktion bis zum nächsten checkHasUserActionDetected
  }
}
